import * as yup from 'yup'

export const configFacturationSchema = yup.object().shape({
  ClienteId: yup.string().required('El cliente es obligatorio'),
  SiteId: yup.string().required('El site es obligatorio'),
  AplicacionId: yup.string().required('El módulo es obligatorio'),
  VistaPermisoId: yup.string().required('La opción es obligatorio'),
  TipoDatoId: yup.string().required('El tipo de dato es obligatorio'),
  ValorInicio: yup
    .string()
    .when('TipoDatoId', {
          is: (val) => console.log(val),
          then: yup.string().required('Dia inicio es requerido'),
          otherwise: yup.string().nullable()
      }),
  ValorFin: yup.string().when('TipoDatoId', {
          is: '01',
          then: yup.string().required('Dia fin es requerido'),
          otherwise: yup.string().nullable()
      }),
  FechaInicio: yup
    .string()
    .typeError('Fecha inicio es requerido')
    .when('TipoDatoId', {
          is: '02',
          then: yup.string().required('Fecha inicio es requerido'),
          otherwise: yup.string().nullable()
      }),
  FechaFin: yup.string().typeError('Fecha fin es requerido').when('TipoDatoId', {
          is: '02',
          then: yup.string().required('Fecha fin es requerido'),
          otherwise: yup.string().nullable()
      }),
})
